import {
  subDays,
  subWeeks,
  startOfYear as soy,
  startOfMonth as som,
  startOfWeek as sow,
  startOfDay as sod,
  endOfYear as eoy,
  endOfMonth as eom,
  endOfWeek as eow,
  endOfDay as eod,
  subMonths,
  subYears,
  isBefore,
  isAfter,
  isValid,
} from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';

export const adjustTimezone = (date) => {
  const businessTimezone = (typeof window !== 'undefined' && window.businessTimezone) || null;

  if (!businessTimezone) {
    return new Date(date.getTime());
  }

  return zonedTimeToUtc(date, businessTimezone);
};

export const newDate = (...options) => {
  const date = new Date(...options);
  const result = adjustTimezone(date);

  return result;
};

export const startOfYear = (input) => {
  const date = soy(input);
  return date;
};

export const startOfMonth = (input) => {
  const date = som(input);
  return adjustTimezone(date);
};

export const startOfWeek = (input, op = { weekStartsOn: 0 }) => {
  const date = sow(input, op);
  return adjustTimezone(date);
};

export const startOfDay = (input) => {
  const date = sod(input);
  return adjustTimezone(date);
};

export const endOfYear = (input) => {
  const date = eoy(input);
  return date;
};

export const endOfMonth = (input) => {
  const date = eom(input);
  return adjustTimezone(date);
};

export const endOfWeek = (input, op = { weekStartsOn: 0 }) => {
  const date = eow(input, op);
  return adjustTimezone(date);
};

export const endOfDay = (input) => {
  const date = eod(input);
  return adjustTimezone(date);
};

export const lastWeek = (...options) => {
  const priorWeek = subWeeks(newDate(...options), 1);
  const start = startOfWeek(priorWeek, { weekStartsOn: 1 });
  const end = endOfWeek(priorWeek, { weekStartsOn: 1 });
  return { start, end, interval: 'day' };
};

export const lastMonth = (...options) => {
  const start = startOfMonth(subMonths(newDate(...options), 1));
  const end = endOfMonth(subMonths(newDate(...options), 1));

  return { start, end, interval: 'day' };
};

export const lastYear = (...options) => {
  const start = startOfYear(subYears(newDate(...options), 1));
  const end = endOfYear(subYears(newDate(...options), 1));

  return { start, end, interval: 'month' };
};

export const yearToDate = (...options) => {
  const start = startOfYear(newDate(...options));
  const end = endOfDay(newDate(...options));

  return { start, end, interval: 'month' };
};

export const last12Months = (...options) => {
  const end = subDays(endOfDay(newDate(...options)), 1);
  const start = subMonths(end, 12);

  return { start, end, interval: 'month' };
};

export const today = (...options) => {
  const start = startOfDay(newDate(...options));
  const end = endOfDay(newDate(...options));

  return { start, end, interval: 'day' };
};

export const yesterday = (...options) => {
  const priorDay = subDays(newDate(...options), 1);
  const start = startOfDay(priorDay);
  const end = endOfDay(priorDay);

  return { start, end, interval: 'day' };
};

export const thisWeek = (...options) => {
  const start = startOfWeek(newDate(...options), { weekStartsOn: 1 });
  const end = endOfWeek(newDate(...options), { weekStartsOn: 1 });

  return { start, end, interval: 'day' };
};

export const last7Days = (...options) => {
  const end = endOfDay(newDate(...options));
  const start = startOfDay(subDays(newDate(...options), 6));
  return { start, end, interval: 'day' };
};

export const last30Days = (...options) => {
  const end = endOfDay(newDate(...options));
  const start = startOfDay(subDays(newDate(...options), 29));
  return { start, end, interval: 'day' };
};

export const last3Months = (...options) => {
  const end = endOfDay(newDate(...options));
  const start = startOfMonth(subMonths(newDate(...options), 3));
  return { start, end, interval: 'month' };
};

export const isBetween = (from, to, date = newDate()) => {
  if (!isValid(from) || !isValid(to)) return false;
  return isBefore(from, date) && isAfter(to, date);
};
